import {Module} from "vuex";

const historyModule: Module<any, any> = {
  state: {
    routesPath: [],
  },
  getters: {},
  mutations: {
    pushToHistory(store, currentPath: string) {
      const arrayLength = store.routesPath.unshift(currentPath);
      if (arrayLength > 10) store.routesPath.pop();
    },
  },
  actions: {},
};

export default historyModule;
